export const New = () => import("./New.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
export const UserGroup = () => import("./UserGroup.vue");
export const MenuAccess = () => import("./MenuAccess.vue");
